"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Wholesale integrations Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@deliverr.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceApi = exports.ServiceApiFactory = exports.ServiceApiFp = exports.ServiceApiAxiosParamCreator = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * ServiceApi - axios parameter creator
 * @export
 */
const ServiceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {any} file
         * @param {string} sellerId
         * @param {string} [batchSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAliasesFromCsv: async (file, sellerId, batchSize, options = {}) => {
            // verify required parameter 'file' is not null or undefined
            (0, common_1.assertParamExists)('createAliasesFromCsv', 'file', file);
            // verify required parameter 'sellerId' is not null or undefined
            (0, common_1.assertParamExists)('createAliasesFromCsv', 'sellerId', sellerId);
            const localVarPath = `/internal/product/alias/bulk-create-from-csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            if (sellerId !== undefined) {
                localVarFormParams.append('sellerId', sellerId);
            }
            if (batchSize !== undefined) {
                localVarFormParams.append('batchSize', batchSize);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {any} file
         * @param {string} labelType
         * @param {string} [description]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLabelTemplate: async (file, labelType, description, options = {}) => {
            // verify required parameter 'file' is not null or undefined
            (0, common_1.assertParamExists)('createLabelTemplate', 'file', file);
            // verify required parameter 'labelType' is not null or undefined
            (0, common_1.assertParamExists)('createLabelTemplate', 'labelType', labelType);
            const localVarPath = `/label-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            if (labelType !== undefined) {
                localVarFormParams.append('labelType', labelType);
            }
            if (description !== undefined) {
                localVarFormParams.append('description', description);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {POFileJsonMapperCreationDTO} pOFileJsonMapperCreationDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPOFileJsonMapper: async (pOFileJsonMapperCreationDTO, options = {}) => {
            // verify required parameter 'pOFileJsonMapperCreationDTO' is not null or undefined
            (0, common_1.assertParamExists)('createPOFileJsonMapper', 'pOFileJsonMapperCreationDTO', pOFileJsonMapperCreationDTO);
            const localVarPath = `/pofile-json-mapper`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(pOFileJsonMapperCreationDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {RetailerCreate} retailerCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRetailer: async (retailerCreate, options = {}) => {
            // verify required parameter 'retailerCreate' is not null or undefined
            (0, common_1.assertParamExists)('createRetailer', 'retailerCreate', retailerCreate);
            const localVarPath = `/retailers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(retailerCreate, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {TradingPartnerRelationCreationData} tradingPartnerRelationCreationData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTradingRelation: async (tradingPartnerRelationCreationData, options = {}) => {
            // verify required parameter 'tradingPartnerRelationCreationData' is not null or undefined
            (0, common_1.assertParamExists)('createTradingRelation', 'tradingPartnerRelationCreationData', tradingPartnerRelationCreationData);
            const localVarPath = `/tradingRelation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(tradingPartnerRelationCreationData, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {any} file
         * @param {string} retailer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateBOLsAndUpload: async (file, retailer, options = {}) => {
            // verify required parameter 'file' is not null or undefined
            (0, common_1.assertParamExists)('generateBOLsAndUpload', 'file', file);
            // verify required parameter 'retailer' is not null or undefined
            (0, common_1.assertParamExists)('generateBOLsAndUpload', 'retailer', retailer);
            const localVarPath = `/label-templates/generate-bill-of-lading`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            if (retailer !== undefined) {
                localVarFormParams.append('retailer', retailer);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {any} file
         * @param {string} retailer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateBillOfLadingData: async (file, retailer, options = {}) => {
            // verify required parameter 'file' is not null or undefined
            (0, common_1.assertParamExists)('generateBillOfLadingData', 'file', file);
            // verify required parameter 'retailer' is not null or undefined
            (0, common_1.assertParamExists)('generateBillOfLadingData', 'retailer', retailer);
            const localVarPath = `/label-templates/generate-bill-of-lading-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            if (retailer !== undefined) {
                localVarFormParams.append('retailer', retailer);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} templateId
         * @param {string} orderId
         * @param {string} sellerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePdf: async (templateId, orderId, sellerId, options = {}) => {
            // verify required parameter 'templateId' is not null or undefined
            (0, common_1.assertParamExists)('generatePdf', 'templateId', templateId);
            // verify required parameter 'orderId' is not null or undefined
            (0, common_1.assertParamExists)('generatePdf', 'orderId', orderId);
            // verify required parameter 'sellerId' is not null or undefined
            (0, common_1.assertParamExists)('generatePdf', 'sellerId', sellerId);
            const localVarPath = `/label-templates/generate-pdf/{templateId}`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }
            if (sellerId !== undefined) {
                localVarQueryParameter['sellerId'] = sellerId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} shipmentId
         * @param {{ [key: string]: number; }} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateSingleLabel: async (shipmentId, requestBody, options = {}) => {
            // verify required parameter 'shipmentId' is not null or undefined
            (0, common_1.assertParamExists)('generateSingleLabel', 'shipmentId', shipmentId);
            // verify required parameter 'requestBody' is not null or undefined
            (0, common_1.assertParamExists)('generateSingleLabel', 'requestBody', requestBody);
            const localVarPath = `/labels/{shipmentId}/generate-single-label`
                .replace(`{${"shipmentId"}}`, encodeURIComponent(String(shipmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} shipmentId
         * @param {SingleLabelData} singleLabelData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateSingleLabelUrl: async (shipmentId, singleLabelData, options = {}) => {
            // verify required parameter 'shipmentId' is not null or undefined
            (0, common_1.assertParamExists)('generateSingleLabelUrl', 'shipmentId', shipmentId);
            // verify required parameter 'singleLabelData' is not null or undefined
            (0, common_1.assertParamExists)('generateSingleLabelUrl', 'singleLabelData', singleLabelData);
            const localVarPath = `/labels/{shipmentId}/generate-single-label-url`
                .replace(`{${"shipmentId"}}`, encodeURIComponent(String(shipmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(singleLabelData, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHealthStatus: async (options = {}) => {
            const localVarPath = `/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} templateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLabelTemplate: async (templateId, options = {}) => {
            // verify required parameter 'templateId' is not null or undefined
            (0, common_1.assertParamExists)('getLabelTemplate', 'templateId', templateId);
            const localVarPath = `/label-templates/{templateId}`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLabelTemplateData: async (orderId, options = {}) => {
            // verify required parameter 'orderId' is not null or undefined
            (0, common_1.assertParamExists)('getLabelTemplateData', 'orderId', orderId);
            const localVarPath = `/label-templates/label-template-data/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} wholesaleOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPOFileByWholesaleOrderId: async (wholesaleOrderId, options = {}) => {
            // verify required parameter 'wholesaleOrderId' is not null or undefined
            (0, common_1.assertParamExists)('getPOFileByWholesaleOrderId', 'wholesaleOrderId', wholesaleOrderId);
            const localVarPath = `/pofile/order-id/{wholesaleOrderId}`
                .replace(`{${"wholesaleOrderId"}}`, encodeURIComponent(String(wholesaleOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPOFileJsonMapper: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getPOFileJsonMapper', 'id', id);
            const localVarPath = `/pofile-json-mapper/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<string>} ids
         * @param {Array<POFileStatus>} [statuses]
         * @param {Array<string>} [sellerIds]
         * @param {Array<POFileProjectionKey>} [projectionKeys]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPOFiles: async (ids, statuses, sellerIds, projectionKeys, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('getPOFiles', 'ids', ids);
            const localVarPath = `/pofile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            if (statuses) {
                localVarQueryParameter['statuses'] = statuses;
            }
            if (sellerIds) {
                localVarQueryParameter['sellerIds'] = sellerIds;
            }
            if (projectionKeys) {
                localVarQueryParameter['projectionKeys'] = projectionKeys;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetailers: async (options = {}) => {
            const localVarPath = `/retailers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoutingReports: async (options = {}) => {
            const localVarPath = `/routingReport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} relationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTradingRelation: async (relationId, options = {}) => {
            // verify required parameter 'relationId' is not null or undefined
            (0, common_1.assertParamExists)('getTradingRelation', 'relationId', relationId);
            const localVarPath = `/tradingRelation/{relationId}`
                .replace(`{${"relationId"}}`, encodeURIComponent(String(relationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTradingRelations: async (options = {}) => {
            const localVarPath = `/tradingRelation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} retailer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUploadUrl: async (retailer, options = {}) => {
            // verify required parameter 'retailer' is not null or undefined
            (0, common_1.assertParamExists)('getUploadUrl', 'retailer', retailer);
            const localVarPath = `/routingReport/uploadUrl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (retailer !== undefined) {
                localVarQueryParameter['retailer'] = retailer;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {any} pofile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processTestPOFile: async (pofile, options = {}) => {
            // verify required parameter 'pofile' is not null or undefined
            (0, common_1.assertParamExists)('processTestPOFile', 'pofile', pofile);
            const localVarPath = `/pofile/process-test-pofile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            if (pofile !== undefined) {
                localVarFormParams.append('pofile', pofile);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {RetryPOFilesRequestDTO} retryPOFilesRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reprocessPOFiles: async (retryPOFilesRequestDTO, options = {}) => {
            // verify required parameter 'retryPOFilesRequestDTO' is not null or undefined
            (0, common_1.assertParamExists)('reprocessPOFiles', 'retryPOFilesRequestDTO', retryPOFilesRequestDTO);
            const localVarPath = `/pofile/reprocess`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(retryPOFilesRequestDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {RetryPOFilesRequestDTO} retryPOFilesRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryPOFiles: async (retryPOFilesRequestDTO, options = {}) => {
            // verify required parameter 'retryPOFilesRequestDTO' is not null or undefined
            (0, common_1.assertParamExists)('retryPOFiles', 'retryPOFilesRequestDTO', retryPOFilesRequestDTO);
            const localVarPath = `/pofile/out-of-stock/retry`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(retryPOFilesRequestDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {POFileUpdateDTO} pOFileUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePOFile: async (id, pOFileUpdateDTO, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('updatePOFile', 'id', id);
            // verify required parameter 'pOFileUpdateDTO' is not null or undefined
            (0, common_1.assertParamExists)('updatePOFile', 'pOFileUpdateDTO', pOFileUpdateDTO);
            const localVarPath = `/pofile/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(pOFileUpdateDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} wholesaleOrderId
         * @param {UpdatePOFileByWholesaleOrderIdRequest} updatePOFileByWholesaleOrderIdRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePOFileByWholesaleOrderId: async (wholesaleOrderId, updatePOFileByWholesaleOrderIdRequest, options = {}) => {
            // verify required parameter 'wholesaleOrderId' is not null or undefined
            (0, common_1.assertParamExists)('updatePOFileByWholesaleOrderId', 'wholesaleOrderId', wholesaleOrderId);
            // verify required parameter 'updatePOFileByWholesaleOrderIdRequest' is not null or undefined
            (0, common_1.assertParamExists)('updatePOFileByWholesaleOrderId', 'updatePOFileByWholesaleOrderIdRequest', updatePOFileByWholesaleOrderIdRequest);
            const localVarPath = `/pofile/order-id/{wholesaleOrderId}`
                .replace(`{${"wholesaleOrderId"}}`, encodeURIComponent(String(wholesaleOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updatePOFileByWholesaleOrderIdRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {TradingPartnerRelationUpdateData} tradingPartnerRelationUpdateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTradingRelation: async (tradingPartnerRelationUpdateData, options = {}) => {
            // verify required parameter 'tradingPartnerRelationUpdateData' is not null or undefined
            (0, common_1.assertParamExists)('updateTradingRelation', 'tradingPartnerRelationUpdateData', tradingPartnerRelationUpdateData);
            const localVarPath = `/tradingRelation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(tradingPartnerRelationUpdateData, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.ServiceApiAxiosParamCreator = ServiceApiAxiosParamCreator;
/**
 * ServiceApi - functional programming interface
 * @export
 */
const ServiceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.ServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {any} file
         * @param {string} sellerId
         * @param {string} [batchSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAliasesFromCsv(file, sellerId, batchSize, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAliasesFromCsv(file, sellerId, batchSize, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {any} file
         * @param {string} labelType
         * @param {string} [description]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLabelTemplate(file, labelType, description, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLabelTemplate(file, labelType, description, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {POFileJsonMapperCreationDTO} pOFileJsonMapperCreationDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPOFileJsonMapper(pOFileJsonMapperCreationDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPOFileJsonMapper(pOFileJsonMapperCreationDTO, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {RetailerCreate} retailerCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRetailer(retailerCreate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRetailer(retailerCreate, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {TradingPartnerRelationCreationData} tradingPartnerRelationCreationData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTradingRelation(tradingPartnerRelationCreationData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTradingRelation(tradingPartnerRelationCreationData, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {any} file
         * @param {string} retailer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateBOLsAndUpload(file, retailer, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateBOLsAndUpload(file, retailer, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {any} file
         * @param {string} retailer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateBillOfLadingData(file, retailer, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateBillOfLadingData(file, retailer, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {number} templateId
         * @param {string} orderId
         * @param {string} sellerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generatePdf(templateId, orderId, sellerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generatePdf(templateId, orderId, sellerId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} shipmentId
         * @param {{ [key: string]: number; }} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateSingleLabel(shipmentId, requestBody, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateSingleLabel(shipmentId, requestBody, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} shipmentId
         * @param {SingleLabelData} singleLabelData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateSingleLabelUrl(shipmentId, singleLabelData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateSingleLabelUrl(shipmentId, singleLabelData, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHealthStatus(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHealthStatus(options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {number} templateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLabelTemplate(templateId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLabelTemplate(templateId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLabelTemplateData(orderId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLabelTemplateData(orderId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} wholesaleOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPOFileByWholesaleOrderId(wholesaleOrderId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPOFileByWholesaleOrderId(wholesaleOrderId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPOFileJsonMapper(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPOFileJsonMapper(id, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {Array<string>} ids
         * @param {Array<POFileStatus>} [statuses]
         * @param {Array<string>} [sellerIds]
         * @param {Array<POFileProjectionKey>} [projectionKeys]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPOFiles(ids, statuses, sellerIds, projectionKeys, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPOFiles(ids, statuses, sellerIds, projectionKeys, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRetailers(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRetailers(options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRoutingReports(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRoutingReports(options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} relationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTradingRelation(relationId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTradingRelation(relationId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTradingRelations(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTradingRelations(options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} retailer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUploadUrl(retailer, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUploadUrl(retailer, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {any} pofile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processTestPOFile(pofile, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.processTestPOFile(pofile, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {RetryPOFilesRequestDTO} retryPOFilesRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reprocessPOFiles(retryPOFilesRequestDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reprocessPOFiles(retryPOFilesRequestDTO, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {RetryPOFilesRequestDTO} retryPOFilesRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retryPOFiles(retryPOFilesRequestDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retryPOFiles(retryPOFilesRequestDTO, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {number} id
         * @param {POFileUpdateDTO} pOFileUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePOFile(id, pOFileUpdateDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePOFile(id, pOFileUpdateDTO, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} wholesaleOrderId
         * @param {UpdatePOFileByWholesaleOrderIdRequest} updatePOFileByWholesaleOrderIdRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePOFileByWholesaleOrderId(wholesaleOrderId, updatePOFileByWholesaleOrderIdRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePOFileByWholesaleOrderId(wholesaleOrderId, updatePOFileByWholesaleOrderIdRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {TradingPartnerRelationUpdateData} tradingPartnerRelationUpdateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTradingRelation(tradingPartnerRelationUpdateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTradingRelation(tradingPartnerRelationUpdateData, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.ServiceApiFp = ServiceApiFp;
/**
 * ServiceApi - factory interface
 * @export
 */
const ServiceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.ServiceApiFp)(configuration);
    return {
        /**
         *
         * @param {any} file
         * @param {string} sellerId
         * @param {string} [batchSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAliasesFromCsv(file, sellerId, batchSize, options) {
            return localVarFp.createAliasesFromCsv(file, sellerId, batchSize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {any} file
         * @param {string} labelType
         * @param {string} [description]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLabelTemplate(file, labelType, description, options) {
            return localVarFp.createLabelTemplate(file, labelType, description, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {POFileJsonMapperCreationDTO} pOFileJsonMapperCreationDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPOFileJsonMapper(pOFileJsonMapperCreationDTO, options) {
            return localVarFp.createPOFileJsonMapper(pOFileJsonMapperCreationDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {RetailerCreate} retailerCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRetailer(retailerCreate, options) {
            return localVarFp.createRetailer(retailerCreate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {TradingPartnerRelationCreationData} tradingPartnerRelationCreationData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTradingRelation(tradingPartnerRelationCreationData, options) {
            return localVarFp.createTradingRelation(tradingPartnerRelationCreationData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {any} file
         * @param {string} retailer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateBOLsAndUpload(file, retailer, options) {
            return localVarFp.generateBOLsAndUpload(file, retailer, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {any} file
         * @param {string} retailer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateBillOfLadingData(file, retailer, options) {
            return localVarFp.generateBillOfLadingData(file, retailer, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} templateId
         * @param {string} orderId
         * @param {string} sellerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePdf(templateId, orderId, sellerId, options) {
            return localVarFp.generatePdf(templateId, orderId, sellerId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} shipmentId
         * @param {{ [key: string]: number; }} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateSingleLabel(shipmentId, requestBody, options) {
            return localVarFp.generateSingleLabel(shipmentId, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} shipmentId
         * @param {SingleLabelData} singleLabelData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateSingleLabelUrl(shipmentId, singleLabelData, options) {
            return localVarFp.generateSingleLabelUrl(shipmentId, singleLabelData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHealthStatus(options) {
            return localVarFp.getHealthStatus(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} templateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLabelTemplate(templateId, options) {
            return localVarFp.getLabelTemplate(templateId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLabelTemplateData(orderId, options) {
            return localVarFp.getLabelTemplateData(orderId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} wholesaleOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPOFileByWholesaleOrderId(wholesaleOrderId, options) {
            return localVarFp.getPOFileByWholesaleOrderId(wholesaleOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPOFileJsonMapper(id, options) {
            return localVarFp.getPOFileJsonMapper(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<string>} ids
         * @param {Array<POFileStatus>} [statuses]
         * @param {Array<string>} [sellerIds]
         * @param {Array<POFileProjectionKey>} [projectionKeys]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPOFiles(ids, statuses, sellerIds, projectionKeys, options) {
            return localVarFp.getPOFiles(ids, statuses, sellerIds, projectionKeys, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetailers(options) {
            return localVarFp.getRetailers(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoutingReports(options) {
            return localVarFp.getRoutingReports(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} relationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTradingRelation(relationId, options) {
            return localVarFp.getTradingRelation(relationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTradingRelations(options) {
            return localVarFp.getTradingRelations(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} retailer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUploadUrl(retailer, options) {
            return localVarFp.getUploadUrl(retailer, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {any} pofile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processTestPOFile(pofile, options) {
            return localVarFp.processTestPOFile(pofile, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {RetryPOFilesRequestDTO} retryPOFilesRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reprocessPOFiles(retryPOFilesRequestDTO, options) {
            return localVarFp.reprocessPOFiles(retryPOFilesRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {RetryPOFilesRequestDTO} retryPOFilesRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryPOFiles(retryPOFilesRequestDTO, options) {
            return localVarFp.retryPOFiles(retryPOFilesRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {POFileUpdateDTO} pOFileUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePOFile(id, pOFileUpdateDTO, options) {
            return localVarFp.updatePOFile(id, pOFileUpdateDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} wholesaleOrderId
         * @param {UpdatePOFileByWholesaleOrderIdRequest} updatePOFileByWholesaleOrderIdRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePOFileByWholesaleOrderId(wholesaleOrderId, updatePOFileByWholesaleOrderIdRequest, options) {
            return localVarFp.updatePOFileByWholesaleOrderId(wholesaleOrderId, updatePOFileByWholesaleOrderIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {TradingPartnerRelationUpdateData} tradingPartnerRelationUpdateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTradingRelation(tradingPartnerRelationUpdateData, options) {
            return localVarFp.updateTradingRelation(tradingPartnerRelationUpdateData, options).then((request) => request(axios, basePath));
        },
    };
};
exports.ServiceApiFactory = ServiceApiFactory;
/**
 * ServiceApi - object-oriented interface
 * @export
 * @class ServiceApi
 * @extends {BaseAPI}
 */
class ServiceApi extends base_1.BaseAPI {
    /**
     *
     * @param {any} file
     * @param {string} sellerId
     * @param {string} [batchSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    createAliasesFromCsv(file, sellerId, batchSize, options) {
        return (0, exports.ServiceApiFp)(this.configuration).createAliasesFromCsv(file, sellerId, batchSize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {any} file
     * @param {string} labelType
     * @param {string} [description]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    createLabelTemplate(file, labelType, description, options) {
        return (0, exports.ServiceApiFp)(this.configuration).createLabelTemplate(file, labelType, description, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {POFileJsonMapperCreationDTO} pOFileJsonMapperCreationDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    createPOFileJsonMapper(pOFileJsonMapperCreationDTO, options) {
        return (0, exports.ServiceApiFp)(this.configuration).createPOFileJsonMapper(pOFileJsonMapperCreationDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {RetailerCreate} retailerCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    createRetailer(retailerCreate, options) {
        return (0, exports.ServiceApiFp)(this.configuration).createRetailer(retailerCreate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {TradingPartnerRelationCreationData} tradingPartnerRelationCreationData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    createTradingRelation(tradingPartnerRelationCreationData, options) {
        return (0, exports.ServiceApiFp)(this.configuration).createTradingRelation(tradingPartnerRelationCreationData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {any} file
     * @param {string} retailer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    generateBOLsAndUpload(file, retailer, options) {
        return (0, exports.ServiceApiFp)(this.configuration).generateBOLsAndUpload(file, retailer, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {any} file
     * @param {string} retailer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    generateBillOfLadingData(file, retailer, options) {
        return (0, exports.ServiceApiFp)(this.configuration).generateBillOfLadingData(file, retailer, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} templateId
     * @param {string} orderId
     * @param {string} sellerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    generatePdf(templateId, orderId, sellerId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).generatePdf(templateId, orderId, sellerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} shipmentId
     * @param {{ [key: string]: number; }} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    generateSingleLabel(shipmentId, requestBody, options) {
        return (0, exports.ServiceApiFp)(this.configuration).generateSingleLabel(shipmentId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} shipmentId
     * @param {SingleLabelData} singleLabelData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    generateSingleLabelUrl(shipmentId, singleLabelData, options) {
        return (0, exports.ServiceApiFp)(this.configuration).generateSingleLabelUrl(shipmentId, singleLabelData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    getHealthStatus(options) {
        return (0, exports.ServiceApiFp)(this.configuration).getHealthStatus(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} templateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    getLabelTemplate(templateId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getLabelTemplate(templateId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    getLabelTemplateData(orderId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getLabelTemplateData(orderId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} wholesaleOrderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    getPOFileByWholesaleOrderId(wholesaleOrderId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getPOFileByWholesaleOrderId(wholesaleOrderId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    getPOFileJsonMapper(id, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getPOFileJsonMapper(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<string>} ids
     * @param {Array<POFileStatus>} [statuses]
     * @param {Array<string>} [sellerIds]
     * @param {Array<POFileProjectionKey>} [projectionKeys]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    getPOFiles(ids, statuses, sellerIds, projectionKeys, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getPOFiles(ids, statuses, sellerIds, projectionKeys, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    getRetailers(options) {
        return (0, exports.ServiceApiFp)(this.configuration).getRetailers(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    getRoutingReports(options) {
        return (0, exports.ServiceApiFp)(this.configuration).getRoutingReports(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} relationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    getTradingRelation(relationId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getTradingRelation(relationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    getTradingRelations(options) {
        return (0, exports.ServiceApiFp)(this.configuration).getTradingRelations(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} retailer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    getUploadUrl(retailer, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getUploadUrl(retailer, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {any} pofile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    processTestPOFile(pofile, options) {
        return (0, exports.ServiceApiFp)(this.configuration).processTestPOFile(pofile, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {RetryPOFilesRequestDTO} retryPOFilesRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    reprocessPOFiles(retryPOFilesRequestDTO, options) {
        return (0, exports.ServiceApiFp)(this.configuration).reprocessPOFiles(retryPOFilesRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {RetryPOFilesRequestDTO} retryPOFilesRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    retryPOFiles(retryPOFilesRequestDTO, options) {
        return (0, exports.ServiceApiFp)(this.configuration).retryPOFiles(retryPOFilesRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {POFileUpdateDTO} pOFileUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    updatePOFile(id, pOFileUpdateDTO, options) {
        return (0, exports.ServiceApiFp)(this.configuration).updatePOFile(id, pOFileUpdateDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} wholesaleOrderId
     * @param {UpdatePOFileByWholesaleOrderIdRequest} updatePOFileByWholesaleOrderIdRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    updatePOFileByWholesaleOrderId(wholesaleOrderId, updatePOFileByWholesaleOrderIdRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration).updatePOFileByWholesaleOrderId(wholesaleOrderId, updatePOFileByWholesaleOrderIdRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {TradingPartnerRelationUpdateData} tradingPartnerRelationUpdateData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    updateTradingRelation(tradingPartnerRelationUpdateData, options) {
        return (0, exports.ServiceApiFp)(this.configuration).updateTradingRelation(tradingPartnerRelationUpdateData, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ServiceApi = ServiceApi;
//# sourceMappingURL=service-api.js.map